import React, { useState } from 'react';
import cx from 'classnames';
import s from '../GrowYourBusiness/s.module.less';
import c from './s.module.less';
import type { TTaskItem } from 'types/home';
import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';

type IProps = {
    isKlarity: boolean;
    task: TTaskItem;
    index: number;
};

const Index: React.FC<IProps> = ({
    isKlarity,
    task,
    index,
}) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleHideModal = () => {
        setShowModal(false);
    };

    const handleRoute = () => {
        navigate('/dashboard/channel');
    };

    const handleTask = () => {
        if (task.completed) {
            return;
        }
        setShowModal(true);
    };

    return (
        <>
            <div
                className={cx(s.listItem, task.completed ? s.completed : '')}
                onClick={() => handleTask()}
            >
                <div className={s.listInner}>
                    <i className={s.num}>{index + 1}</i>
                    <div className={s.content}>
                        <div className={s.goalTitle}>{task.taskName}</div>
                        <div className={s.goalDescription}>{task.description}</div>
                    </div>
                    <div className={s.arrow} />
                </div>
            </div>
            <Modal
                title="List on all relevant channels 🎯"
                centered
                open={showModal}
                onCancel={handleHideModal}
                width={534}
                footer={null}
            >
                <div className={s.modalContent}>
                    <p>
                        Carefully select and utilize targeted platforms that align with
                        your specialties and patient demographics.
                    </p>
                    <p>
                        By strategically positioning your practice across these channels,
                        you open doors to new patient opportunities and expand your market
                        presence. Each precisely chosen channel acts as a powerful
                        conduit, connecting you with potential patients who are actively
                        seeking your services.
                    </p>
                    <div className={s.buttonWrap}>
                        <Button type="primary" onClick={() => handleRoute()}>
                            List on more channels
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Index;
